import { useTranslation } from 'react-i18next';

interface Props {
  name: string;
  required: boolean;
}

const BooleanInputs = ({ name, required }: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <fieldset className="">
        <div className="space-y-2">
          <div className="flex items-center">
            <label className="text-md wt-body-font block flex cursor-pointer items-center font-semibold text-gray-700">
              <input
                name={name}
                value={'true'}
                type="radio"
                required={required}
                defaultChecked={false}
                className="h-5 w-5 cursor-pointer border-gray-300 text-wt-primary focus:ring-wt-primary"
              />

              <span className="pl-2">{t('forms.labels.true')}</span>
            </label>
          </div>
          <div className="flex items-center">
            <label className="text-md wt-body-font block flex cursor-pointer items-center font-semibold text-gray-700">
              <input
                name={name}
                value={'false'}
                type="radio"
                required={required}
                defaultChecked={false}
                className="h-5 w-5 cursor-pointer border-gray-300 text-wt-primary focus:ring-wt-primary"
              />
              <span className="pl-2">{t('forms.labels.false')}</span>
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default BooleanInputs;
